import { render, staticRenderFns } from "./ModalBackofficeOrcamento.vue?vue&type=template&id=b1937300&scoped=true"
import script from "./ModalBackofficeOrcamento.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeOrcamento.vue?vue&type=script&lang=ts"
import style0 from "./ModalBackofficeOrcamento.vue?vue&type=style&index=0&id=b1937300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1937300",
  null
  
)

export default component.exports